import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase.js';

/**
 * The callable SDK sends an `undefined` property as `null`, which a request
 * schema's `.optional()` rejects (INTERNAL). Drop undefined fields — at any
 * depth — before sending. Payloads are plain JSON, so the round trip is exact.
 */
export function withoutUndefined<T>(req: T): T {
  return req === undefined ? req : (JSON.parse(JSON.stringify(req)) as T);
}

/** A typed callable whose request always goes through {@link withoutUndefined}.
 *  Shared by billing (doc 42) and the account emails (doc 88). */
export const call = <Req, Res>(name: string) => {
  const fn = httpsCallable<Req, Res>(functions, name);
  return async (req: Req): Promise<Res> => (await fn(withoutUndefined(req))).data;
};
